import styled from 'styled-components'

import { customScrollBar, ColumnFlex } from 'components/common/genericStyles'

export const Container = styled.div`
    width: 100%;
    height: 85%;
    ${ColumnFlex}
    ${props => props.children.length > 7 && 'overflow-y: auto;'}
    ${customScrollBar}
    color: white;
    font-size: 1.5rem;
`
